import Link from './Link';
export * from './styles/_link.styled';
export * from './styles/link-image.styled';
export { LinkImage } from './LinkImage';
export * from './Link';
export default Link;
//# sourceMappingURL=index.js.map